import { Action } from '@ngrx/store';

import { CandidatesPageFilter } from './filters.reducer';

// TODO: refactor to use actionCreator
export enum CandidatesPageFilterActionTypes {
  Set = '[Candidates Page Filter] Set',
  Clear = '[Candidates Page Filter] Clear',
  SetSkills = '[Candidates Page Filter] SetSkills',
}

export class CandidatesPageFilterSet implements Action {
  readonly type = CandidatesPageFilterActionTypes.Set;

  constructor(public payload?: Partial<CandidatesPageFilter>) {}
}

export class CandidatesPageFilterClear implements Action {
  readonly type = CandidatesPageFilterActionTypes.Clear;
}

export class CandidatesPageFilterSetSkills implements Action {
  readonly type = CandidatesPageFilterActionTypes.SetSkills;

  constructor(public payload?: Partial<CandidatesPageFilter>) {}
}

export type CandidatesPageFilterActionsUnion =
  | CandidatesPageFilterSet
  | CandidatesPageFilterClear
  | CandidatesPageFilterSetSkills;
